import React from 'react';
import { motion } from 'framer-motion';
import SectionHeading from '../SectionHeading';

const HumanScale = () => (
  <section className="py-24 bg-brand-dark border-t border-white/5">
    <div className="max-w-5xl mx-auto px-6 lg:px-8">
      <SectionHeading title="The Heart of the Chronicle" subtitle="Human Scale" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-start">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }}>
          <p className="text-gray-300 leading-relaxed text-lg mb-6">
            What elevates this book above ordinary science fiction is its insistence on the human scale. Amidst the terraforming operations and antimatter engines, the author gives us <span className="text-white">breakfast conversations, morning swims in bioluminescent oceans,</span> and daughters who are quietly terrified of not being ready enough to leave for the stars.
          </p>
          <p className="text-gray-400 leading-relaxed">
            We follow multi-generational family lineages — the Vasquezes, the Tanakas, the Osei-Okonkwos, the Rivera-Mwangis — across centuries, watching how one person's courage or cowardice ripples through descendants who never knew them.
          </p>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="space-y-6">
          <div className="bg-brand-surface border border-white/5 rounded-2xl p-6">
            <p className="text-gray-300 italic leading-relaxed text-sm">
              "Celeste Moreau-Bouazizi, swimming in Venusian oceans made from melted Jovian ice, honors the grief of her great-grandfather who mourned the destruction of the old Venus — even as she celebrates the world that replaced it."
            </p>
          </div>
          <div className="bg-brand-surface border border-white/5 rounded-2xl p-6">
            <p className="text-gray-300 italic leading-relaxed text-sm">
              "Eseosa Rivera-Mwangi, director of Neptune's Heliopause Observatory, holds her daughter's hand in a cold corridor and speaks in the understated Neptunian way about what it means to carry a civilization's voice into the dark."
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);

export default HumanScale;